import React from "react";
import {TextField} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconButton from "@material-ui/core/IconButton";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {useSelector} from "react-redux";
import {multiLanguageValue, shortcutCombinationMatcher} from "../../../../../Components/JsonScreen/Utils/lib";
import clsx from "clsx";
import {useDeepCompareCallback} from "use-deep-compare";
import {useEventListener} from "../../../../../Hooks/useEventListener";

const useStyles = makeStyles(() => ({
    textFieldRoot: {
        '& .MuiInput-underline:before': {
            borderBottomColor: 'rgba(0,0,0,0.22)', // Semi-transparent underline
        },
    },
    inputRoot: {
        '&[class*="MuiInput-root"]': {
            paddingRight: 0,
            '& $input': {
                padding: '4px 4px',
            },
        },
        '&[class*=MuiAutocomplete-inputRoot]': {
            paddingRight: '0px'
        },
        '&[class*="MuiOutlinedInput-root"]': {
            padding: '1px',
            paddingRight: '3px !important',
            '& $input': {
                padding: '2px 4px !important',
            },
        },
    },
    option: {
        minHeight: 2,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        cursor: 'pointer',
        paddingTop: 1,
        boxSizing: 'border-box',
        outline: '0',
        WebkitTapHighlightColor: 'transparent',
        paddingBottom: 2,
        paddingLeft: 16,
        paddingRight: 16,
    },
    paper: {
        display: 'none'
    },
    clearIndicator: {
        display: 'none',
    },
    popupIndicator: {display: 'none'},
    tag: {
        height: '24px'
    },
}));

const SimpleField = (props) => {
    const {
        onChange, onBlur, onKeyDown, onChangeTextField,
        fieldValue, filterValue, fieldRef, error, label, isMobile,
        fieldStyles, required, disabled, onBlurProps, onFocus, autofocus, loading,
        id, isOpen, fieldPresentation, placeholder, componentId, screenName, path, events, doActions
    } = props;
    const classes = useStyles();
    const userLanguage = useSelector(state => state.app.userLanguage);
    const customStyles = (isMobile || fieldStyles.presentation === 'standard') ? {
            marginTop: 4,
            width: '100%'
        } :
        {
            width: '100%',
            margin: fieldStyles.margin,
            paddingTop: fieldStyles.withoutPadding ? 0 : !isMobile && 3,
            paddingLeft: fieldStyles.withoutPadding ? 0 : !isMobile && 2,
        };
    const inputPropsStyles = {
        style: {
            height: fieldStyles.height
        }
    };
    const onKeyDownHandler = useDeepCompareCallback((e) => {
        const onKeydownEvent = events?.find(v => v.event === 'onKeydown')
        if (onKeydownEvent) {
            shortcutCombinationMatcher(e, onKeydownEvent.shortcut, () => {
                doActions(onKeydownEvent.actions, {currentField: {value: fieldValue}})
            })
        }

    }, [events, fieldValue])

    useEventListener('keydown', onKeyDownHandler, fieldRef.current)

    return (
        <Autocomplete
            value={fieldValue}
            onChange={(event, value) => onChange(value)}
            disabled={disabled}
            open={false}
            loading={loading}
            classes={{
                inputRoot: classes.inputRoot,
                clearIndicator: classes.clearIndicator,
                popupIndicator: classes.popupIndicator,
                option: classes.option,
                paper: classes.paper,
                tag: classes.tag,
            }}
            id={componentId}
            className={clsx("sb-entity-external-field", screenName)}
            getOptionLabel={option => option.label || ''}
            inputValue={filterValue}
            onBlur={(e) => {
                onBlur();
                onBlurProps(e)
            }}
            options={[]}
            renderInput={params =>
                <TextField
                    {...params}
                    required={required && (fieldValue === null || !fieldValue.length)}
                    autoComplete={'off'}
                    label={(isMobile || fieldStyles.presentation === 'standard') && multiLanguageValue(label, userLanguage)}
                    placeholder={multiLanguageValue(placeholder, userLanguage)}
                    variant={isMobile ? 'standard' : fieldPresentation}
                    onFocus={onFocus}
                    onKeyDown={onKeyDown}
                    fullWidth={isMobile ? true : fieldStyles.fullWidth}
                    autoFocus={autofocus}
                    className={
                        fieldStyles.withoutStyles ?
                            'horizontal-fields-table' :
                            'form-dynamic'
                    }
                    error={error.length > 0}
                    classes={{root: classes.textFieldRoot}}
                    ref={fieldRef}
                    type={'string'}
                    onChange={onChangeTextField}
                    style={customStyles}
                    name={path}
                    inputProps={{
                        ...params.inputProps,
                        id: id ? id : params.inputid,
                        ...inputPropsStyles
                    }}
                    InputProps={{
                        ...params.InputProps,
                        style: {
                            ...fieldStyles.conditionalStyles || {}
                        },
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={12}/> : null}
                                <IconButton style={{padding: 0, left: isMobile ? 0 : -6}}
                                            tabIndex={-1}
                                            disabled={disabled}>
                                    <ArrowDropDownIcon
                                        style={{
                                            color: disabled ? 'rgba(0, 0, 0, 0.38)' : 'rgba(0, 0, 0, 0.54)',
                                            transform: isOpen === true ? 'rotate(180deg)' : "rotate(0deg)"
                                        }}/>
                                </IconButton>
                                {params.InputendAdornment}
                            </React.Fragment>
                        ),
                    }}
                />}
        />
    )
};

export default SimpleField

SimpleField.propTypes = {}